import { render, staticRenderFns } from "./toolsTextGenerate.vue?vue&type=template&id=60b6ea53&scoped=true&"
import script from "./toolsTextGenerate.vue?vue&type=script&lang=js&"
export * from "./toolsTextGenerate.vue?vue&type=script&lang=js&"
import style0 from "./toolsTextGenerate.vue?vue&type=style&index=0&id=60b6ea53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6ea53",
  null
  
)

export default component.exports